var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagnifier(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.46663 8.30002H6.1333C5.85997 8.30002 5.6333 8.07335 5.6333 7.80002C5.6333 7.52668 5.85997 7.30002 6.1333 7.30002H9.46663C9.73997 7.30002 9.96663 7.52668 9.96663 7.80002C9.96663 8.07335 9.73997 8.30002 9.46663 8.30002Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.80005 9.96666C7.52672 9.96666 7.30005 9.74 7.30005 9.46666V6.13333C7.30005 5.86 7.52672 5.63333 7.80005 5.63333C8.07338 5.63333 8.30005 5.86 8.30005 6.13333V9.46666C8.30005 9.74 8.07338 9.96666 7.80005 9.96666Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66659 14.5C3.89992 14.5 0.833252 11.4333 0.833252 7.66668C0.833252 3.90001 3.89992 0.833344 7.66659 0.833344C11.4333 0.833344 14.4999 3.90001 14.4999 7.66668C14.4999 11.4333 11.4333 14.5 7.66659 14.5ZM7.66659 1.83334C4.44659 1.83334 1.83325 4.45334 1.83325 7.66668C1.83325 10.88 4.44659 13.5 7.66659 13.5C10.8866 13.5 13.4999 10.88 13.4999 7.66668C13.4999 4.45334 10.8866 1.83334 7.66659 1.83334Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6666 15.1667C14.54 15.1667 14.4133 15.12 14.3133 15.02L12.98 13.6867C12.7866 13.4933 12.7866 13.1733 12.98 12.98C13.1733 12.7867 13.4933 12.7867 13.6866 12.98L15.02 14.3133C15.2133 14.5067 15.2133 14.8267 15.02 15.02C14.92 15.12 14.7933 15.1667 14.6666 15.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.c673c55f97b24d017a0a734b9a70c914.svg";
export { ForwardRef as ReactComponent };